import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/top-features-icon3.svg")